import { getMimeTypeByExtension } from "../File/mimeType";
import { anchorBase64Download } from "../../utils/anchor-base64-download/anchor-base64-download";
import { createToast } from "../../components/toast/toast";
import axios from "axios";

export async function downloadDocumentHelper({ urlFile, name, isApp = false }) {
    try {
        const actualUrl = typeof urlFile === 'object' && urlFile.pathFile ? urlFile.pathFile : urlFile;

        const splitedPath = actualUrl.split(".");
        const fileExtension = splitedPath[splitedPath.length - 1].split("?")[0];

        const { base64: downloadedFileBase64, mimeType: responseMimeType } = await arrayBufferToBase64(actualUrl);

        const mimeType = responseMimeType || getMimeTypeByExtension(fileExtension);
        anchorBase64Download(
            isApp,
            mimeType,
            name + "." + fileExtension,
            downloadedFileBase64,
        );
    } catch (erro) {
        console.error("Erro no download do documento:", erro);
        const delay = 5000;
        const msg = "Ocorreu um erro ao baixar o arquivo!";
        createToast("Erro", msg, "danger", delay);
    }
}

export async function arrayBufferToBase64(url) {
    if (!url) throw new Error("URL vazia");

    const resp = await axios.get(url, {
        responseType: "arraybuffer",
        baseURL: ""
    });

    const mimeType = resp.headers['content-type'];

    const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        const blob = new Blob([resp.data]);
        reader.readAsDataURL(blob);
        reader.onload = () => {
            resolve(reader.result.split(',')[1]);
        };
        reader.onerror = (error) => reject(error);
    });

    console.log('base64: ', base64)
    console.log('mimeType: ', mimeType)
    return { base64, mimeType };
}
